import React from "react";
import Popover from "../../../../../../../../common-deprecated/components/popover/aem/Popover";
import { BnbLabel } from "../../../../../utils/labels";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import Preloader, * as PreloaderStyles from "../../../../../../../../common-deprecated/styles/v2/lexus/custom/Preloader";
import useETA from "../../../../../hooks/shared/useETA";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import { MODAL_ALTERNATIVES_ETA } from "../../../../../utils/modalConstants";
import ETADeliveryLabel from "../../ETADeliveryLabel";
import * as Text from "../../../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Styles from "../styles/Basket";
import ButtonWithIcon from "../../../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { isRTL } from "../../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { trackEtaOpen } from "../../../../../utils/tracking";
import useETADeliveryLabel from "../../../../../hooks/shared/useETADeliveryLabel";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const BasketETA = (): JSX.Element | null => {
    const { show, loading, date, disclaimer } = useETA();
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const etaDeliveryLabel = useETADeliveryLabel(date);

    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const isRtl = isRTL(commonSettings);

    if (!show) return null;
    if (loading)
        return (
            <PreloaderStyles.PreLoaderWrapper data-testid="basket-eta-loader">
                <Preloader />
            </PreloaderStyles.PreLoaderWrapper>
        );
    if (!etaDeliveryLabel) return null;

    return (
        <Styles.EtaWrapper>
            <div>
                <ETADeliveryLabel date={date} />
                {disclaimer && (
                    <>
                        {" "}
                        {/* TODO: popover gets bold styling from title */}
                        <Popover showOnClick content={disclaimer} />
                    </>
                )}
            </div>
            <ButtonWithIcon
                onClick={() => {
                    trackEtaOpen();
                    dispatch(showModal({ type: MODAL_ALTERNATIVES_ETA }));
                }}
            >
                <Text.IconButton mr={isRtl ? 1 : 0} ml={isRtl ? 0 : 1}>
                    <BnbLabel label="earlierAvailableCars" />
                </Text.IconButton>
                <Icon variant="arrowRight" />
            </ButtonWithIcon>
        </Styles.EtaWrapper>
    );
};

export default BasketETA;
